import React, { useState, useEffect } from 'react';
import "../Layout/productManage.css";
import "../Layout/layout.css";

function ProductManage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const products = [
    {id:1,img:"5-2-vitamin-b.jpg",name:"Viên sủi Kudos Daily Vitamins Plus Biotin & Ginseng hương cam giúp bổ sung vitamin cho cơ thể (20 viên)",discount:15},
    {id:2,img:"5-2-vitamin-b.jpg",name:"vitamin D",discount:0},
    {id:3,img:"5-2-vitamin-b.jpg",name:"vitamin E",discount:10},
    {id:4,img:"5-2-vitamin-b.jpg",name:"vitamin F",discount:0},
    {id:5,img:"5-2-vitamin-b.jpg",name:"vitamin B1",discount:20},
    {id:6,img:"5-2-vitamin-b.jpg",name:"vitamin E1",discount:0},
    {id:7,img:"5-2-vitamin-b.jpg",name:"vitamin F1",discount:10},
    {id:8,img:"5-2-vitamin-b.jpg",name:"vitamin B2",discount:5},
    {id:9,img:"5-2-vitamin-b.jpg",name:"vitamin C",discount:0}
  ];
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop products={products}/> : <Mobile />;
  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = ({products }) => {
  return (
    <body class='Desktop' >
     <div className='content-product'>
      <div className='table-product'>
        <table>
          <thead>
            <tr>
              <th>MSP</th>
              <th>Tên</th>
            </tr>
          </thead>
          {products.map(product =>
          <tbody>
            <tr>
              <td>{product.id}</td>
              <td>{product.name}</td>
            </tr>
          </tbody>  
          )}
          {/* <tfoot>
            <tr>
              <th>Name</th>
              <th>Instrument</th>
            </tr>
          </tfoot> */}
        </table>
      </div>
      <div className='contronl-product'>
        <input type='text' placeholder='.....'></input>
        <div className='contronl-button'>
          <button>Tên SP</button>
          <button>Mã SP</button>
        </div>
        <div className='contronl-button'>
          <button>Giá SP</button>
          <button>Loại SP</button>
        </div>
        <div className='contronl-button'>
          <button>NSX</button>
          <button>Mã SP</button>
        </div>
        <div className='contronl-button'>
          <button>Tên</button>
          <button>Mã SP</button>
        </div>
      </div>
     </div>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default ProductManage;
